import { FieldInput } from "@qw/ui";
import type { FC } from "react";

export interface PlaybookNameFieldProps {
  canEdit: boolean;
}

export const PlaybookNameField: FC<PlaybookNameFieldProps> = ({ canEdit }) => (
  <FieldInput
    name="name"
    placeholder="Playbook name"
    disabled={!canEdit}
    readOnly={!canEdit}
    inputProps={{
      className:
        "text-3xl font-bold border-0! bg-transparent px-0 ring-0! ring-offset-0! rounded-none! outline-none! shadow-none! disabled:opacity-100 disabled:bg-transparent",
    }}
    className="mb-2 flex-0!"
  />
);
